import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Hotel(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4 6a4 4 0 014-4h9a4 4 0 014 4v14h1a1 1 0 110 2h-8a1 1 0 110-2h5V6a2 2 0 00-2-2H8a2 2 0 00-2 2v3a1 1 0 01-2 0V6zm4.222 5.874a1.5 1.5 0 00-2.844 0l-.692 2.066-2.18.02a1.5 1.5 0 00-.878 2.705l1.75 1.297-.654 2.078a1.5 1.5 0 002.302 1.672L6.8 20.447l1.774 1.265a1.5 1.5 0 002.302-1.672l-.655-2.078 1.751-1.297a1.5 1.5 0 00-.879-2.705l-2.179-.02-.692-2.066zm-.39 3.556L6.8 12.35l-1.032 3.08-3.248.03 2.61 1.932-.975 3.099L6.8 18.605l2.645 1.886-.976-3.099 2.61-1.933-3.248-.029zM14 11h2v2h-2v-2zm2-5h-2v2h2V6zM9 6h2v2H9V6zm7 10h-2v2h2v-2z",
    clipRule: "evenodd"
  }));
}

export default Hotel;